
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M18.534 15.685a5.024 5.024 0 01-1.784-3.844V9.75c0-2.64-1.96-4.824-4.5-5.19v-.81a.75.75 0 10-1.5 0v.81c-2.54.366-4.5 2.55-4.5 5.19v2.091c0 1.484-.65 2.885-1.791 3.85A1.314 1.314 0 005.313 18l12.374-.001a1.314 1.314 0 00.847-2.315zM11.5 21a2.817 2.817 0 002.755-2.25h-5.51A2.817 2.817 0 0011.5 21z"}})])])
          )
        }
      }
    